<script setup lang="ts">
import { type SectionType } from '@openesg/supabase/models'

export interface Props {
  type: SectionType['Row']['category']
  section?: string
  size?: string
}
const props = defineProps<Props>()

const badge = computed(() => {
  return {
    initial: props.type[0],
    label: props.type,
  }
})

const badgeClass = computed(() => {
  return (
    'esg-category-' +
    badge.value.initial +
    ' esg-category-size-' +
    (props.size || 'base')
  )
})

const { parseToHTML } = useMarkdown({})
const sectionLabel = asyncComputed(
  async () => await parseToHTML(JSON.parse(props?.section || '')),
  null
)
</script>

<template lang="pug">
div(
  v-if="badge"
  class="esg-category inline-flex flex-row antialiased rounded-tr-[0.6875rem] md:rounded-tr-[0.875rem]"
  :class="badgeClass"
)
  div(
    class="esg_initial px-12 py-5 md:p-9 md:px-18 text-base font-bold uppercase text-gray-100 rounded-tr-[0.6875rem] md:rounded-tr-[0.875rem]"
  ) {{ badge.initial }}
  div(
    class="esg_label flex items-center px-9 text-2xs md:px-18 md:text-xs font-semibold capitalize"
  ) {{ badge.label }}

  div(
    v-if="sectionLabel"
    class="esg_metric border-2 hidden md:flex items-center px-9 text-2xs md:px-18 md:text-xs font-semibold bg-gray-100 rounded-tr-[0.6875rem] md:rounded-tr-[0.875rem]"
  )
    span(v-html="sectionLabel")
</template>

<style scoped lang="postcss">
.esg-category {
  &-e {
    @apply bg-category-e-light text-category-e-dark;
    .esg_initial {
      @apply bg-category-e;
    }
    .esg_metric {
      @apply border-category-e-light;
    }
  }
  &-s {
    @apply bg-category-s-light text-category-s;
    .esg_initial {
      @apply bg-category-s;
    }
    .esg_metric {
      @apply border-category-s-light;
    }
  }
  &-g {
    @apply bg-category-g-light text-category-g;
    .esg_initial {
      @apply bg-category-g;
    }
    .esg_metric {
      @apply border-category-g-light;
    }
  }

  &-size-sm {
    border-top-right-radius: 0.6875rem;
    .esg_initial {
      @apply pl-12 pr-15 py-5;
      border-top-right-radius: 0.6875rem;
    }
    .esg_label {
      @apply px-9 text-2xs;
    }

    .esg_metric {
      @apply px-9 text-2xs;
      border-top-right-radius: 0.6875rem;
    }
  }
}
</style>
